import { Wrap } from './styles';

import Icon from '@map/components/Icons';

const GridFake = ({ arrayY }) => {
  
  return (
    <Wrap>        
        <div>
          <div className='coordinates1'>
          {arrayY[0]}
          </div>
          <div className='coordinates2'>
          {arrayY[2]}
          </div>
          <div className='coordinates3'>
          {arrayY[3]}
          </div>
          <div className='coordinates4'>
          {arrayY[4]}
          </div>
          <div className='coordinates5'>
          {arrayY[5]}
          </div>
          <div className='coordinates6'>
          {arrayY[6]}
          </div>
          <div className='coordinates7'>
          {arrayY[7]}
          </div>
          <div className='coordinates8'>
          {arrayY[1]}
          </div>
        </div>        
        <Icon i="map-print-verticalgridfake"/>
    </Wrap>
  );
};


export default GridFake;